export default __webpack_public_path__ + "static/media/benefits2New.b116f948.gif";